document.addEventListener('DOMContentLoaded', function() {
  const header = document.querySelector('.elemital-header-wrapper');
  if (!header) return;

  let lastScrollTop = 0;
  const hideThreshold = 100; // Lướt qua 100px mới bắt đầu giấu Header

  // 1. LOGIC CUỘN ẨN / HIỆN THANH HEADER CORNER
  window.addEventListener('scroll', function() {
    let scrollTop = window.pageYOffset || document.documentElement.scrollTop;

    // Nếu bảng thực đơn di động đang mở, đóng băng trạng thái đứng im của Header
    if (header.querySelector('.e-menu-drawer.is-open')) return;

    // KHI Ở TRÊN CÙNG: Trả về dạng trong suốt
    if (scrollTop <= 50) {
      header.classList.add('is-transparent');
      header.classList.remove('is-hidden', 'is-sticky');
    } 
    // KHI LƯỚT XUỐNG DƯỚI: Giấu Header
    else if (scrollTop > lastScrollTop && scrollTop > hideThreshold) {
      header.classList.add('is-hidden');
      header.classList.remove('is-transparent', 'is-sticky');
    } 
    // KHI LƯỚT NGƯỢC LÊN: Hiện Header nền xanh rêu
    else if (scrollTop < lastScrollTop) {
      header.classList.add('is-sticky');
      header.classList.remove('is-hidden', 'is-transparent');
    }

    lastScrollTop = scrollTop <= 0 ? 0 : scrollTop; // Chống lỗi cuộn âm trên Safari
  });

  // 2. LOGIC ĐÓNG / MỞ DRAWER BẰNG JAVASCRIPT NATIVE
  const hamburgerBtn = header.querySelector('.e-header-hamburger');
  const drawerMenu = header.querySelector('.e-menu-drawer');
  const closeBtn = header.querySelector('.e-menu-drawer-close');
  const overlay = header.querySelector('.e-menu-drawer-overlay');

  if (hamburgerBtn && drawerMenu) {
    function openMenu() {
      drawerMenu.classList.add('is-open');
      document.body.style.overflow = 'hidden'; // Khóa cứng cuộn dọc trang chính phía sau
    }

    function closeMenu() {
      drawerMenu.classList.remove('is-open');
      document.body.style.overflow = ''; // Trả lại quyền cuộn bình thường
    }

    hamburgerBtn.addEventListener('click', openMenu);
    if (closeBtn) closeBtn.addEventListener('click', closeMenu);
    if (overlay) overlay.addEventListener('click', closeMenu);
  }

  // 3. LOGIC DROPDOWN GIỎ HÀNG (CLICK VÀO ICON CART)
  const cartWrapper = header.querySelector('.e-cart-wrapper');
  const cartBtn = header.querySelector('.e-cart-btn');

  if (cartWrapper && cartBtn) {
    function closeCartDropdown() {
      cartWrapper.classList.remove('is-open');
      cartBtn.setAttribute('aria-expanded', 'false');
    }

    function openCartDropdown() {
      cartWrapper.classList.add('is-open');
      cartBtn.setAttribute('aria-expanded', 'true');
      refreshCartDropdown();
    }

    function refreshCartDropdown() {
      fetch('/cart.js')
        .then(function(res) { return res.json(); })
        .then(function(cart) { renderCartDropdown(cart); })
        .catch(function(e) { console.error(e); });
    }

    function renderCartDropdown(cart) {
      var itemsWrap = cartWrapper.querySelector('.e-cart-dropdown-items');
      var subtotalWrap = cartWrapper.querySelector('.e-cart-dropdown-subtotal');
      var countBadge = cartWrapper.querySelector('.e-cart-count');

      if (countBadge) {
        countBadge.textContent = cart.item_count;
        countBadge.hidden = cart.item_count === 0;
      }

      if (!itemsWrap) return;

      if (cart.item_count === 0) {
        itemsWrap.innerHTML = '<p class="e-cart-dropdown-empty">Your cart is empty.</p>';
        if (subtotalWrap) subtotalWrap.remove();
        return;
      }

      itemsWrap.innerHTML = cart.items.map(function(item) {
        var imgSrc = item.image ? item.image + (item.image.indexOf('?') > -1 ? '&' : '?') + 'width=100' : '';
        var img = imgSrc ? '<img src="' + imgSrc + '" alt="" loading="lazy">' : '';
        return (
          '<div class="e-cart-dropdown-item">' +
            '<div class="e-cart-dropdown-image">' + img + '</div>' +
            '<div class="e-cart-dropdown-text">' +
              '<span class="e-cart-dropdown-title">' + item.product_title + '</span>' +
              '<span class="e-cart-dropdown-meta">Qty: ' + item.quantity + ' · ' + formatMoney(item.final_line_price) + '</span>' +
            '</div>' +
          '</div>'
        );
      }).join('');

      var totalHtml = '<span>Subtotal</span><span>' + formatMoney(cart.total_price) + '</span>';
      if (subtotalWrap) {
        subtotalWrap.innerHTML = totalHtml;
      } else {
        var newSubtotal = document.createElement('div');
        newSubtotal.className = 'e-cart-dropdown-subtotal';
        newSubtotal.innerHTML = totalHtml;
        itemsWrap.insertAdjacentElement('afterend', newSubtotal);
      }
    }

    function formatMoney(cents) {
      return (window.Shopify && Shopify.formatMoney)
        ? Shopify.formatMoney(cents, window.moneyFormat || '${{amount}}')
        : '$' + (cents / 100).toFixed(2);
    }

    cartBtn.addEventListener('click', function(e) {
      e.stopPropagation();
      cartWrapper.classList.contains('is-open') ? closeCartDropdown() : openCartDropdown();
    });

    document.addEventListener('click', function(e) {
      if (!cartWrapper.contains(e.target)) closeCartDropdown();
    });

    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape') closeCartDropdown();
    });
  }
});